/**
 * Base class for API response errors
 */
export abstract class AbstractResponseError extends Error {
  constructor(message?: string) {
    super(message);

    // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export class UnexpectedResponseError extends AbstractResponseError {
  constructor(message = "Unexpected response") {
    super(message);
  }
}

export class ResponseError extends AbstractResponseError {
  constructor(code: string, message = "") {
    if (message) {
      super(`${code} (${message})`);
    } else {
      super(code);
    }
  }
}
